declare const VERSION: string;

export const config = {
	getFullVersion: () => VERSION,
	getCurrentVersion: () => VERSION.split('-', 2)[1],
	getCurrentBuild: () => VERSION.split('-', 3)[2],
};
